var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2509_4826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2346 7.01913C18.6346 5.41913 16.4388 4.42603 14.0001 4.42603C9.1229 4.42603 5.18359 8.37637 5.18359 13.2536C5.18359 18.1309 9.1229 22.0812 14.0001 22.0812C18.116 22.0812 21.5477 19.2674 22.5298 15.4605H20.2346C19.3298 18.0315 16.8801 19.8743 14.0001 19.8743C10.3477 19.8743 7.37946 16.906 7.37946 13.2536C7.37946 9.6012 10.3477 6.63292 14.0001 6.63292C15.8319 6.63292 17.465 7.3943 18.6567 8.59706L15.1036 12.1502H22.8277V4.42603L20.2346 7.01913Z",
    fill: "#FF2600"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.ad8278c0e9a15de68467d0c0b994085a.svg";
export { ForwardRef as ReactComponent };